<template lang="pug">
.form-group
  input.form-control(
    v-if="!off",
    type="text",
    v-model="displayValue",
    @blur="isActive=false",
    @focus="isActive=true"
  )
  p.form-text.text-muted(:class="{invalid: invalid}") {{ helpText }}
</template>

<style lang="scss">
p.form-text.invalid {
  color: #9b0000 !important;
}
</style>

<script>
import {
  ctrGoalToImpressionRate,
  impressionRateToCtrGoal,
} from "@/utils/impression-rate-ctr-goal";

export default {
  name: "CtrGoal",
  props: {
    value: {
      type: [String, Number],
    },
  },
  data() {
    return {
      isActive: false,
      invalid: false,
    };
  },
  computed: {
    off() {
      // -1 means: do not override (use publisher default).
      return this.value === -1;
    },
    displayValue: {
      get() {
        // Convert stored `impression_rate` to UI CTR Goal.
        const p = impressionRateToCtrGoal(this.value);

        // While editing, show raw number without "%".
        if (this.isActive) return p.toString();

        // When idle, show a formatted value.
        if (this.value === 100) return "";
        if (this.value === 0) return "";

        return `${p}%`;
      },
      set(modified) {
        // Normalize user input to a numeric CTR Goal.
        let s = modified.toString();
        let [whole, frac] = s.split(".");
        if (frac && frac.length > 2) {
          s = `${whole}.${frac.slice(0, 2)}`;
        }
        // eslint-disable-next-line no-useless-escape
        const p = parseFloat(s.replace(/[^\d\.]/g, "")) || 0;

        // Validate UI bounds and emit stored `impression_rate`.
        this.invalid = p < 0 || p > 10000;
        const r = ctrGoalToImpressionRate(p);
        this.$emit("input", r);
      },
    },
    helpText() {
      // Explain the meaning and edge cases to the user.
      if (this.value === -1) return "No change (as sent by publisher)";
      if (this.value === 100) return "Only impressions";
      if (this.value === 0) return "Only clicks";
      const p = impressionRateToCtrGoal(this.value);
      const imp = Math.round(100 / p);
      return `${imp} impressions per click`;
    },

  },
};
</script>

